
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/people/user-rights",
      function () {
        return require("private-next-pages/csr/people/user-rights.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/people/user-rights"])
      });
    }
  